(function () {
    const _ = require('lodash');
    const $ = require('jquery');
    const Vue = require('vue').default;
    const Bloodhound = require('bloodhound-js');
    require('typeahead.js');

    if ($('#search').length == 0) {
        return;
    }

    // The default form method is `GET`, which is a simple form of search that
    // works without javascript. To handle the fancier stuff, we're going to use
    // a different controller action - which is `POST` only.
    $('#search').attr('method', 'post');

    // This list container is hidden on page load so we don't see the flash of
    // Vue.js template markup.
    $('#search [v-for="segment in segments"]').css('display', 'block');

    const vm = new Vue({
        el: '#search',
        data: {
            category: $('[name="category"]').val(),
            segments: [],
            properties: [],
            listType: $('[name="list-type"]').eq(0).val(),
            showControls: false,
            results: '',
            resultsOpacity: 1,
        },
        watch: {
            segments: function () {
                var vm = this;
                Vue.nextTick(function () {
                    vm.count();
                });
            },
        },
        computed: {
            placeholder: function () {
                if (this.segments.length == 0) {
                    return 'Neighbourhood or ref no…';
                }
                return 'Add neighbourhood…';
            },
            commercial: function () {
                return this.category == 1;
            },
            residential: function () {
                return this.category == 2;
            },
            sales: function () {
                return this.listType == 1;
            },
            rental: function () {
                return this.listType == 3;
            },
        },
        methods: {
            focus: function () {
                this.showControls = true;
            },
            count: function () {
                var vm = this;
                var req = $.ajax({
                    url: '/api/count?' + $('#search').serialize(),
                    method: 'GET',
                });
                vm.resultsOpacity = 0.3;
                req.fail(function () {
                    vm.results = '';
                    vm.resultsOpacity = 1;
                });
                req.done(function (res) {
                    vm.results = res.text;
                    vm.resultsOpacity = 1;
                });
            },
            add: function (suggestion) {
                if (suggestion.type == 'property') {
                    this.properties = [ suggestion, ];
                    this.submit();
                } else {
                    this.segments.push(suggestion);
                }
            },
            submit: function () {
                Vue.nextTick(function () {
                    $('#search').submit();
                });
            },
            remove: function (value) {
                this.segments = _.filter(this.segments, function (segment) {
                    return segment.value !== value;
                });
            },
        },
    });

    vm.count();

    // $('#search .fieldset__toggle').removeAttr('style');

    const source = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        remote: {
            wildcard: '%QUERY',
            rateLimitWait: 100,
            url: '/api/autocomplete?q=%QUERY',
            prepare: function (query, settings) {
                settings.url = '/api/autocomplete?q=' + query + '&category=' + vm.category;
                _.each(vm.segments, function (segment) {
                    settings.url += '&segments[]=' + segment.value;
                });

                return settings;
            },
        },
    });

    var $typeahead = $('.typeahead');
    $typeahead.typeahead({
        hint: false,
        minLength: 1,
        highlight: true,
    }, {
        limit: 12,
        name: 'areas',
        display: 'display',
        source: source,
        templates: {
            pending: $('template#pending').html(),
            empty: $('template#empty').html(),
        },
    });

    $typeahead.bind('typeahead:select', function (e, suggestion) {
        vm.add(suggestion);
        $typeahead.typeahead('val', '');
    });
}());
